import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ToastController } from '@ionic/angular';
import { NaploService } from '../naplo.service';

// NAPLO – Tanúsítvány / E-mail aláírás: a könyvelőiroda aláíró tanúsítványainak (.p12/.pfx) kezelése
// a NAPLO-n belül (mert a könyvelő nem éri el a fő admin menüt). Feltöltés + az S/MIME e-mail-aláíró
// tanúsítvány kijelölése. A kimenő e-maileket ezután a rendszer ezzel digitálisan aláírja.
@Component({
  selector: 'app-naplo-tanusitvany',
  templateUrl: './tanusitvany.component.html',
  styleUrls: ['../naplo-shared.scss', './tanusitvany.component.scss'],
})
export class TanusitvanyComponent implements OnInit {
  get intezmeny() { return this.naplo.aktiv.intezmeny; }
  certek: any[] = [];
  smime: { kijelolt: any; betoltve: boolean } = { kijelolt: null, betoltve: false };
  file: File | null = null;
  fileNev = '';
  jelszo = '';
  feltoltes = false;

  constructor(private naplo: NaploService, private http: HttpClient, private toast: ToastController) {}

  async ngOnInit() { await this.naplo.init(); await this.betolt(); }

  async betolt() {
    if (!this.intezmeny) return;
    try {
      this.certek = await firstValueFrom(this.http.get<any[]>('/api/nyilvantartas/tanusitvanyok/' + this.intezmeny)) || [];
      this.smime = await firstValueFrom(this.http.get<any>('/api/nyilvantartas/smime-signer'));
    } catch { /* néma */ }
  }

  valaszt(ev: any) {
    const f = ev?.target?.files?.[0];
    if (!f) return;
    if (!/\.(p12|pfx)$/i.test(f.name)) { this.hiba('Csak .p12 vagy .pfx fájlt lehet feltölteni.'); return; }
    this.file = f; this.fileNev = f.name;
  }

  async feltolt() {
    if (!this.file || !this.intezmeny) return;
    this.feltoltes = true;
    const fd = new FormData();
    fd.append('file', this.file);
    fd.append('password', this.jelszo || '');
    try {
      const r: any = await firstValueFrom(this.http.post('/api/upload/' + this.intezmeny, fd));
      if (r && r.message && !r.status) this.hiba(r.message);
      else this.ok('Tanúsítvány feltöltve.');
      this.file = null; this.fileNev = ''; this.jelszo = '';
      await this.betolt();
    } catch (e: any) {
      this.hiba(e?.error?.message || 'Hibás tanúsítvány vagy jelszó.');
    } finally { this.feltoltes = false; }
  }

  async emailAlairo(row: any) {
    try {
      const r: any = await firstValueFrom(this.http.post('/api/nyilvantartas/smime-signer', { id: row.id }));
      if (r?.signer && r.signer.ok === false) this.hiba('Kijelölve, de nem tölthető be: ' + (r.signer.reason || 'ismeretlen hiba'));
      else this.ok('E-mail aláíró tanúsítvány beállítva.');
      await this.betolt();
    } catch { this.hiba('Nem sikerült beállítani.'); }
  }

  async alairasKi() {
    try { await firstValueFrom(this.http.post('/api/nyilvantartas/smime-signer', {})); this.ok('E-mail aláírás kikapcsolva.'); await this.betolt(); }
    catch { this.hiba('Nem sikerült kikapcsolni.'); }
  }

  async torol(row: any) {
    if (!confirm('Biztosan törli ezt a tanúsítványt?')) return;
    try { await firstValueFrom(this.http.request('delete', '/api/nyilvantartas/tanusitvanyok/' + row.id, { body: { id: row.id } })); this.ok('Tanúsítvány törölve.'); await this.betolt(); }
    catch { this.hiba('Nem sikerült törölni.'); }
  }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 1800, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 3000, color: 'danger' })).present(); }
}
